import AccordionItemCore from '@studiometa/js-toolkit/components/Accordion/AccordionItem';
import withBreakpointObserver from '@studiometa/js-toolkit/decorators/withBreakpointObserver';

/**
 * MobileReadmoreAccordion class.
 */
export default class MobileReadmoreAccordion extends withBreakpointObserver(AccordionItemCore) {
  /**
   * Class config.
   * @return {Object}
   */
  get config() {
    return {
      ...super.config,
      name: 'MobileReadmoreAccordion',
      activeBreakpoints: 'xxs, xs',
    };
  }

  /**
   * Open
   */
  async open() {
    await super.open();
    this.$refs.less.style.display = '';
    this.$refs.more.style.display = 'none';
  }

  /**
   * Close
   */
  async close() {
    await super.close();
    this.$refs.less.style.display = 'none';
    this.$refs.more.style.display = '';
  }

  /**
   * Destroyed
   */
  destroyed() {
    this.$el.style.height = '';
  }
}
